/* eslint-disable no-unused-vars */
/* eslint-disable default-param-last */
const initialState = {
  values: [],
  isEdited: false,
  isAdded: false,
  action: null,
};
const dzikirReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case 'ADD_DZIKIR':
      return {
        ...state,
        values: payload,
      };
    case 'DEL_DZIKIR':
      return {
        ...state,
        values: [],
        isEdited: false,
      };
    case 'EDITED_DZIKIR':
      return {
        ...state,
        isEdited: payload,
      };
    case 'ADDED_DZIKIR':
      return {
        ...state,
        isAdded: payload,
      };
    case 'SET_ACTION_DZIKIR':
      return {
        ...state,
        action: payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default dzikirReducer;
